<template>
  <div class="list-container">
    <!--    List-->
    <div class="terms-container">
      <div class="legal-protocol">
        <!--      Condiciones Especiales del Préstamo-->

        <div v-if="!isNormalTag" class="order-container">
          <div class="title">Condiciones Especiales del Préstamo</div>
          <div class="desc">Número de contrato: {{ agreementNo }}</div>
          <div class="desc">Fecha de solicitud: {{ disbursementDate }}</div>
          <div class="desc">
            Entre {{ Borrower }} con DNI/NIE número {{ idNo }}, con domicilio en
            {{ address }}, correo electrónico {{ invest }}, en adelante
            denominado el “Prestatario”; y la sociedad NEBULA FINANCE SA, con
            N.I.F.: A75607945, domiciliada en Paseo De La Castellana 194 -
            Madrid – 28046, en adelante denominado el “Prestamista”.
          </div>

          <div class="desc-li">Condiciones Especiales del Préstamo</div>

          <table class="protocol-table">
            <tbody>
              <tr>
                <td>Importe Principal del Préstamo</td>
                <td>{{ orderAmount }} euros</td>
              </tr>
              <tr>
                <td>Intereses</td>
                <td>{{ interestFee }} euros</td>
              </tr>

              <tr>
                <td>Comisión de Apertura</td>
                <td>{{ managementFee }} euros</td>
              </tr>

              <tr>
                <td>Total a devolver</td>
                <td>{{ repayMoney }} euros</td>
              </tr>
              <tr>
                <td>TIN aplicable al Préstamo</td>
                <td>{{ apr }}%</td>
              </tr>
              <tr>
                <td>Duración del Préstamo</td>
                <td>{{ period }} días</td>
              </tr>
              <tr>
                <td>Fecha de vencimiento</td>
                <td>
                  <div
                    class="td-content"
                    v-for="(item, index) in repaymentList"
                    :key="index"
                  >
                    {{ item.stabilizeManage }}: {{ item.identifyBroker }}
                  </div>
                </td>
              </tr>
              <tr>
                <td>Tasa Anual Equivalente (TAE)</td>
                <td>{{ tae }}%</td>
              </tr>

              <tr>
                <td>Reembolso del Préstamo</td>
                <td>
                  En la fecha de vencimiento de cada periodo, salvo el pago
                  realizado mediante la sección "PAGAR", se cargará el importe
                  correspondiente a tu(s) tarjeta(s).<br />
                  <div
                    class="td-content"
                    v-for="(item, index) in repaymentList"
                    :key="index"
                  >
                    {{ item.stabilizeManage }}: {{ item.identifyClarify }} euros
                  </div>
                  Si optas por realizar el reembolso manualmente, en ningún caso
                  el importe mínimo del reembolso será inferior a cinco (5)
                  euros. Si no has introducido ninguna tarjeta al realizar la
                  solicitud o posteriormente, también puedes realizar el pago
                  mediante tarjeta de débito en la sección habilitada a tal
                  efecto en nuestra página web o aplicación móvil.
                </td>
              </tr>

              <tr>
                <td>Amortización Anticipada</td>
                <td>Revisa Artículo 10 de las Condiciones Generales</td>
              </tr>

              <tr>
                <td>Intereses por impago</td>
                <td>
                  Se aplicará una penalización por demora del {{ lateRate }}% diario
                  sobre el importe recibido por el Prestatario, con una
                  penalización máxima del 100% del principal, además del importe
                  impagado. Se aplicará además una comisión fija de reclamación
                  por impago de
                  {{ collectionFee }} € por cada incidencia de impago. Esta
                  comisión será exigible por cada retraso y es independiente de
                  cualquier otro cargo o interés aplicable según las Condiciones
                  Generales.
                </td>
              </tr>

              <tr>
                <td>Cobro de Deudas Vencidas</td>
                <td>
                  El préstamo impagado seguirá generando intereses (véase
                  Artículo 12 de las Condiciones Generales).
                </td>
              </tr>

              <tr>
                <td>Correo electrónico del Prestamista</td>
                <td>{{ emailNo }}</td>
              </tr>
            </tbody>
          </table>

          <br />
          <div class="desc">
            Otra información: Las Condiciones Especiales anteriores han sido
            negociadas individualmente entre el solicitante del préstamo y el
            Prestamista de acuerdo con las comunicaciones efectuadas. El
            solicitante del préstamo reconoce que esta opción le fue ofrecida
            antes de firmar el Contrato de Préstamo.
          </div>
          <br />
          <div class="desc">
            La concesión del préstamo dependerá del Análisis de Riesgo y
            Solvencia realizado por el Prestamista. En caso de aprobación, el
            Prestamista realizará una transferencia por el importe del préstamo
            a la cuenta bancaria indicada en la Solicitud de Préstamo del
            Prestatario.
          </div>

          <div class="space-400"></div>
        </div>

        <!--        normal - container-->
        <div class="normal-container">
          <van-image
            class="logo-icon"
            :src="require('@/assets/image/logo.svg')"
          />
          <div class="desc-li">
            AVISO ESPECIAL. Antes de aprobar y aceptar los términos y
            condiciones, asegúrese de haber leído detenidamente todos los
            términos. Si tiene alguna pregunta sobre el contenido o la
            información proporcionada en el Sitio Web o la Aplicación Móvil, no
            tome ninguna acción adicional. Puede consultar con nuestro servicio
            de atención al cliente en línea o llamar a nuestra línea directa al
            {{ servicePhoneNo }} para aclaraciones. Tenga en cuenta, además, que
            el producto que está a punto de contratar es un PRODUCTO FINANCIERO
            que, en caso de impago, podría generar costes adicionales, que
            encontrará detallados más adelante. Por favor, lea atentamente el
            contrato.
          </div>
          <div class="space-400" />
          <div class="subtitle text-center">NÉBULA FINANCE S.A.</div>
          <div class="subtitle text-center">
            CONDICIONES GENERALES DEL CONTRATO DE PRÉSTAMO
          </div>
          <div class="desc-li">Artículo 1: Objeto</div>
          <div class="desc">
            Las presentes Condiciones Generales (en adelante, las “Condiciones
            Generales”) junto con las Condiciones Especiales constituyen el
            contrato de préstamo (en adelante, el “Contrato” o “Contrato de
            Préstamo”) entre usted (en adelante, el “Cliente” o “Prestatario”) y
            NÉBULA FINANCE S.A. (en adelante, el “Prestamista” o “NÉBULA”), que
            opera bajo la denominación comercial “Prestalight”. Según lo
            anterior, el Prestatario recibirá, tras la aprobación por parte del
            Prestamista y en un único pago, la cantidad de dinero indicada en
            las Condiciones Especiales, la cual deberá ser devuelta junto con
            los intereses ordinarios acordados, también en un único pago, en la
            fecha de vencimiento indicada en las Condiciones Especiales.
          </div>

          <div class="desc">
            El Cliente declara expresamente haber leído previamente, con
            suficiente antelación y detenimiento, el contenido del Contrato,
            entendiendo plenamente tanto el significado de sus cláusulas como
            los preceptos legales mencionados, asumiendo sin reservas los
            derechos y obligaciones contenidos en el mismo, y prestando
            libremente su consentimiento para la formalización y celebración del
            Contrato.
          </div>

          <div class="desc-li">Artículo 2: Términos y Definiciones</div>
          <div class="desc">
            En las Condiciones Generales, los siguientes términos tendrán los
            significados indicados a continuación:
          </div>
          <div class="desc">
            2.1 Préstamo: Contrato mediante el cual el Prestamista pone a
            disposición del Prestatario una cantidad específica de dinero
            durante un período determinado, comprometiéndose el Prestatario a
            devolver al Prestamista el principal recibido, así como a pagar los
            intereses ordinarios y los costes derivados de la tramitación y
            gestión del préstamo en la fecha de vencimiento acordada, conforme a
            lo establecido en las Condiciones Especiales.
          </div>

          <div class="desc">
            El préstamo objeto de este Contrato pertenece a la categoría
            específica de los microcréditos, caracterizados por ser préstamos de
            importes reducidos, generalmente concedidos por períodos inferiores
            a un año, y que no requieren garantías reales ni personales. Dado
            que las entidades que conceden microcréditos no están sujetas a
            regulación ni supervisión por parte del Banco de España, esta
            institución no recopila datos sobre los precios de los microcréditos
            ni publica estadísticas al respecto.
          </div>

          <div class="desc">
            El préstamo se regirá por estas Condiciones Generales y las
            Condiciones Especiales, por la Ley 22/2007, de 11 de julio, sobre
            Comercialización a Distancia de Servicios Financieros destinados a
            los Consumidores, la Ley 16/2011, de 24 de junio, de Contratos de
            Crédito al Consumo, la Ley 34/2002, de 11 de julio, de Servicios de
            la Sociedad de la Información y de Comercio Electrónico, el Real
            Decreto Legislativo 1/2007, de 16 de noviembre, por el que se
            aprueba el Texto Refundido de la Ley General para la Defensa de los
            Consumidores y Usuarios y otras leyes complementarias, así como por
            cualquier otra normativa general aplicable.
          </div>
          <div class="desc">
            2.2 Prestamista: la sociedad NÉBULA FINANCE S.A., de nacionalidad
            española, con domicilio social en PASEO DE LA CASTELLANA 194 MADRID
            28046-MADRID, y Número de Identificación Fiscal (N.I.F.) A75607945,
            constituida mediante escritura pública de fecha 3 de diciembre de
            2024, otorgada ante el Notario D. Ángel Almoguera Gómez con números
            de protocolo 6141/2024 y 217/2025, inscrita en el Registro Mercantil
            de Madrid, inscripción número 1/2025/10084,0, Diario 2024, entrada
            16680.
          </div>
          <div class="desc">
            2.3 Solicitante del Préstamo: persona física mayor de 18 años, con
            plena capacidad jurídica y domicilio permanente en España, que
            cumple con las Condiciones Generales y que manifiesta, mediante la
            Solicitud de Préstamo, su voluntad de solicitar al Prestamista la
            concesión de un préstamo.
          </div>
          <div class="desc">
            2.4 Solicitud de Préstamo: declaración formal mediante la cual el
            Solicitante del Préstamo pide el préstamo. La Solicitud de Préstamo
            se envía por el Cliente al Prestamista en formato electrónico a
            través del Servicio a Distancia, siguiendo el procedimiento descrito
            en las Condiciones Generales.
          </div>
          <div class="desc">
            2.5 Prestatario: Solicitante del Préstamo una vez que su solicitud
            ha sido aceptada por el Prestamista.
          </div>
          <div class="desc">
            2.6 Decisión del Préstamo: resolución final adoptada por el
            Prestamista sobre la concesión o denegación del préstamo.
          </div>
          <div class="desc">
            2.7 Parte/Partes: el Solicitante del Préstamo, el Prestatario y el
            Prestamista, considerados individualmente; y las Partes,
            conjuntamente, se refieren al Prestamista y al Solicitante del
            Préstamo o al Prestatario.
          </div>
          <div class="desc">
            2.8 Servicio a Distancia: técnicas de comunicación mediante redes
            telemáticas proporcionadas por el Prestamista al Cliente para
            efectuar el registro en la Aplicación Móvil y/o en el Sitio Web,
            realizar la Solicitud de Préstamo, formalizar el Contrato y obtener
            la Decisión del Préstamo. A efectos de contratos firmados a
            distancia, se refiere al proceso de contratación realizado a través
            del Sitio Web, Aplicación Móvil, SMS o cualquier otra técnica
            telemática de comunicación y contratación empleada por el Cliente.
          </div>
          <div class="desc">
            2.9 Comisión de Apertura: importe fijo cobrado por el Prestamista
            tras la formalización del Contrato de Préstamo, destinado a cubrir
            los costes administrativos y de gestión derivados del procesamiento
            y administración del préstamo otorgado por NÉBULA.
          </div>
          <div class="desc">
            2.10 Sitio Web: página web del Prestamista www.prestalight.com.
          </div>
          <div class="desc">
            2.11 Aplicación Móvil: aplicación o APP denominada Prestalight
            propiedad de NÉBULA FINANCE S.A., mediante la cual el Cliente puede
            gestionar, acceder a información contractual y consultar el estado
            del producto contratado.
          </div>
          <div class="desc">
            2.12 Día Hábil: cualquier día que no sea fin de semana (sábado y
            domingo) ni festivo.
          </div>
          <div class="desc">
            2.13 Datos Personales: cualquier información relativa al Solicitante
            o Prestatario que permita identificarle o pueda identificarle.
          </div>
          <div class="desc">
            2.14 Tratamiento de Datos Personales: operaciones y procedimientos
            técnicos, automatizados o no, que permiten la recogida, registro,
            almacenamiento, procesamiento, modificación, bloqueo, supresión y
            transferencia de los datos personales necesarios para la gestión del
            préstamo y los servicios complementarios ofrecidos por el
            Prestamista conforme a la política de privacidad de NÉBULA.
          </div>
          <div class="desc">
            2.15 Consentimiento del Solicitante: manifestación libre,
            inequívoca, específica e informada por la cual el Solicitante o
            Prestatario acepta el tratamiento de sus datos personales por parte
            del Prestamista.
          </div>

          <div class="desc">
            2.16 Fecha de vencimiento: la fecha en la que el Cliente debe
            reembolsar, pagar y satisfacer el importe adeudado de conformidad
            con las Condiciones Particulares del Contrato.
          </div>
          <div class="desc">
            2.17 Tasa Anual Equivalente (TAE): el coste total del crédito para
            el consumidor, expresado como un porcentaje anual fijo del importe
            total del crédito concedido. La TAE se ha calculado conforme al
            Anexo I de la Ley 16/2011, de 24 de junio, de Contratos de Crédito
            al Consumo.
          </div>
          <div class="desc">
            2.18 Información Normalizada Europea sobre el Crédito al Consumo: la
            información estandarizada europea sobre el crédito al consumo
            elaborada de conformidad con el Anexo II de la Ley 16/2011, de 24 de
            junio, de Contratos de Crédito al Consumo.
          </div>
          <div class="desc">
            2.19 Condiciones Generales: cláusulas establecidas en el presente
            documento, que establecen y configuran el régimen jurídico y las
            normas de funcionamiento aplicables a la contratación, así como los
            derechos y obligaciones de las Partes.
          </div>
          <div class="desc">
            2.20 Condiciones Particulares: documento que refleja las condiciones
            específicas del Contrato (como el tipo de interés aplicable y la
            fecha de vencimiento), que será puesto a disposición del Solicitante
            del Préstamo antes de que este asuma cualquier obligación.
          </div>
          <div class="desc">
            2.21 Análisis de Riesgo y Solvencia: evaluación y calificación
            crediticia de la capacidad del Solicitante del Préstamo para
            devolver el importe solicitado, basada en información suficiente,
            incluyendo el acceso a datos contenidos en ficheros de solvencia
            patrimonial y crédito. Este análisis permite al Prestamista tomar
            una Decisión de Préstamo y, en su caso, aprobar una Línea de Crédito
            dentro del Préstamo.
          </div>

          <div class="desc-li">Artículo 3: Contratación a distancia</div>
          <div class="desc">
            3.1 El Contrato de Préstamo se celebra en modalidad de contratación
            a distancia, entendiéndose como tal aquella que se formaliza sin la
            presencia física simultánea del prestador del servicio (en este
            caso, el Prestamista o NÉBULA) y el cliente o usuario (el
            Prestatario), habiéndose utilizado exclusivamente técnicas de
            comunicación a distancia tanto en el proceso de negociación como en
            la conclusión efectiva del mismo.
          </div>
          <div class="desc">
            3.2 El Prestamista y el Prestatario reconocen y aceptan que la
            oferta y la aceptación, y por tanto la perfección del Contrato,
            quedarán registradas mediante la incorporación de sus decisiones en
            un soporte duradero, de forma que permita al Solicitante del
            Préstamo almacenar la información que le ha sido dirigida, de manera
            que pueda acceder fácilmente a ella durante un período de tiempo
            adecuado a los fines para los que se destina y que permita la
            reproducción inalterada de dicha información.
          </div>

          <div class="desc-li">
            Artículo 4: Manifestaciones previas del Solicitante del Préstamo
          </div>
          <div class="desc">
            El Solicitante del Préstamo, mediante la firma del presente
            Contrato, manifiesta y garantiza que:
          </div>
          <div class="desc">
            (a) posee plena capacidad legal para contratar, así como la libre
            administración de sus bienes;
          </div>
          <div class="desc">
            (b) ha analizado detenidamente y con detalle los riesgos y costes
            derivados del producto que se propone contratar, disponiendo de la
            capacidad económica necesaria para hacer frente, a su vencimiento,
            al pago del capital prestado, así como a los intereses ordinarios
            del Préstamo y al resto de las cantidades devengadas como
            consecuencia de la formalización del presente Contrato, siendo
            consciente de que este producto constituye únicamente un medio
            adecuado para resolver situaciones transitorias y concretas de falta
            de liquidez, no pudiendo considerarse como un mecanismo idóneo para
            la financiación a medio o largo plazo;
          </div>
          <div class="desc">
            (c) el Prestamista ha facilitado de manera simultánea la Información
            Normalizada Europea sobre el Crédito al Consumo, así como el resto
            de la documentación exigida conforme a lo establecido en la Ley
            16/2011, de 24 de junio, de Contratos de Crédito al Consumo, la Ley
            22/2007, de 11 de julio, sobre comercialización a distancia de
            servicios financieros destinados a los consumidores, el Real Decreto
            Legislativo 1/2007, de 16 de noviembre, por el que se aprueba el
            texto refundido de la Ley General para la Defensa de los
            Consumidores y Usuarios, y demás normativas complementarias
            aplicables;
          </div>
          <div class="desc">
            (d) la información proporcionada por el Solicitante del Préstamo
            durante el proceso de contratación es veraz, auténtica, real y
            actualizada, en especial la relativa a sus datos personales,
            domicilio e identidad, y que dispone de los documentos
            justificativos y de respaldo a tal efecto, los cuales podrán ser
            requeridos por NÉBULA para su verificación durante toda la vigencia
            de la relación contractual; y
          </div>
          <div class="desc">
            (e) a los efectos de lo dispuesto en la legislación vigente en
            materia de prevención del blanqueo de capitales, declara ser el
            titular actual y real de la cuenta bancaria indicada en su Solicitud
            de Préstamo.
          </div>

          <div class="desc-li">Artículo 5: Solicitud de Préstamo</div>
          <div class="desc">
            5.1 Para ser Solicitante del Préstamo es imprescindible tener
            domicilio permanente en España, ser mayor de 18 años y no tener
            restricciones legales para ejercer su capacidad de obrar.
          </div>
          <div class="desc">
            5.2 El Solicitante del Préstamo deberá realizar su solicitud a
            través del Servicio a Distancia elegido. En la Página Web y la
            Aplicación Móvil, el Solicitante del Préstamo encontrará un
            formulario que deberá ser cumplimentado y enviado al Prestamista por
            medios telemáticos. El Solicitante deberá proporcionar la siguiente
            información:
          </div>
          <ol class="protocol-list protocol-list-ordered">
            <li>Nombre y apellidos.</li>
            <li>Fecha de nacimiento.</li>
            <li>D.N.I./N.I.E.</li>
            <li>Domicilio permanente en España.</li>
            <li>Importe del préstamo solicitado.</li>
            <li>Duración.</li>
            <li>Cuenta bancaria vigente.</li>
            <li>Correo electrónico.</li>
            <li>Número de teléfono móvil.</li>
            <li>Número de la Seguridad Social.</li>
            <li>Ingresos mensuales medios.</li>
            <li>Fuente principal de ingresos.</li>
          </ol>
          <div class="desc">
            5.3 Mediante el envío de la Solicitud de Préstamo, el Solicitante
            declara y manifiesta que no existen circunstancias conocidas que
            puedan afectar negativamente a su solvencia y capacidad crediticia
            para reembolsar el importe solicitado, y que toda la información y
            documentación facilitada al Prestamista es veraz, exacta y
            actualizada, conforme a lo expuesto en el Artículo 4.
          </div>
          <div class="desc">
            5.4 La confirmación de la Solicitud de Préstamo por parte del
            Solicitante implica una declaración de voluntad para perfeccionar el
            Contrato; no obstante, dicha perfección queda supeditada a la
            emisión de una Decisión Positiva de Préstamo por parte del
            Prestamista, que será comunicada al Prestatario por correo
            electrónico, SMS, notificaciones en la Aplicación Móvil u otro medio
            electrónico disponible en función de la tecnología existente.
          </div>
          <div class="desc">
            5.5 Una vez confirmada la Solicitud de Préstamo, el Prestamista
            procederá a analizar la solvencia del Solicitante en base a la
            documentación aportada y a la información que pueda obtener de
            terceros.
          </div>
          <div class="desc">
            5.6 El Prestamista utilizará, entre otros factores, la información
            facilitada por el Solicitante para realizar el Análisis de Riesgo y
            Solvencia, teniendo en cuenta aspectos tales como los ingresos, el
            importe solicitado, la edad, la capacidad de pago, experiencia
            previa, análisis de ficheros de solvencia patrimonial y crediticia,
            información proveniente de empresas externas que proporcionen datos
            relevantes, y técnicas estadísticas, entre otros. La Decisión
            Positiva de Préstamo quedará supeditada, además de a los criterios
            del análisis mencionado y al cumplimiento de las obligaciones en
            materia de prevención del blanqueo de capitales, a la inexistencia
            de pagos pendientes o deudas con terceros, a no ser parte en
            procedimientos judiciales que afecten a su solvencia patrimonial y
            crediticia, y a la veracidad, exactitud y actualidad de toda la
            información proporcionada.
          </div>
          <div class="desc">
            5.7 El Prestamista informará al Solicitante, por correo electrónico
            u otros medios de comunicación a distancia (incluyendo SMS), de la
            correcta recepción de la Solicitud de Préstamo.
          </div>
          <div class="desc">
            5.8 El Préstamo podrá tener una duración de hasta sesenta y un (61) días naturales, de conformidad con las Condiciones Particulares, a contar desde la recepción por parte del Prestatario de la Decisión de Préstamo.
          </div>

          <div class="desc-li">Artículo 6: Conclusion of The Loan Contract</div>
          <div class="desc">
            6.1 El importe inicial del Préstamo disponible que el Prestatario
            podrá solicitar se indicará siempre en el simulador/calculadora que
            el Prestamista pone a disposición del Prestatario con carácter
            previo a la Solicitud del Préstamo. El importe máximo a solicitar
            dependerá de si se trata del primer Préstamo contratado por el
            Prestatario o de un préstamo posterior.
          </div>
          <div class="desc">
            6.2 La Solicitud de Préstamo podrá ser rechazada siempre que el
            Prestamista lo considere oportuno, y especialmente cuando estime que
            la información facilitada por el Solicitante del Préstamo no es
            exacta o correcta.
          </div>
          <div class="desc">
            6.3 El Prestamista podrá limitar el importe máximo del Préstamo, y
            con carácter general, no se concederán préstamos cuando el
            Solicitante haya incurrido anteriormente en impago o cuando la
            Solicitud contenga un domicilio que ya figure en un préstamo o
            solicitud de préstamo anterior.
          </div>
          <div class="desc">
            6.4 En caso de que el Prestamista rechace la Solicitud de Préstamo,
            es decir, cuando la Decisión de Préstamo sea negativa, el
            Prestamista no estará obligado a comunicar al Solicitante los
            motivos del rechazo. No obstante lo anterior, cuando sea aplicable y
            conforme a lo previsto en el artículo 15 de la Ley 16/2011 de
            Contratos de Crédito al Consumo (LCCC) o en el artículo 20.1(f) de
            la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos
            Personales y garantía de los derechos digitales, si la denegación de
            la solicitud de crédito se basa en la consulta a un fichero de
            solvencia patrimonial y crédito, el Prestamista informará al
            Solicitante del resultado de dicha consulta y de los datos de la
            base de datos consultada.
          </div>
          <div class="desc">
            6.5 El Préstamo se considerará perfeccionado en el momento en que se
            cumplan conjuntamente los siguientes dos requisitos: i) el
            Solicitante del Préstamo haya completado correctamente la Solicitud
            de Préstamo; y ii) el Solicitante reciba del Prestamista la Decisión
            de Préstamo positiva.
          </div>
          <div class="desc">
            6.6 La comunicación mediante la cual el Prestatario formula la
            Solicitud de Préstamo implica: i) que ha revisado las Condiciones
            Generales y Condiciones Particulares, la Política de Privacidad y la
            Información Normalizada Europea sobre el Crédito al Consumo; ii) que
            las acepta íntegramente; y iii) que desea que el Préstamo le sea
            abonado inmediatamente en la cuenta bancaria indicada en la
            Solicitud o mediante el método de pago elegido.
          </div>
          <div class="desc">
            6.7 Una vez formalizado el Préstamo, el Prestamista realizará una
            transferencia bancaria por el importe aceptado a la cuenta bancaria
            facilitada por el Prestatario en la Solicitud del Préstamo.
          </div>
          <div class="desc">
            6.8 Una vez que el Prestatario reciba el importe solicitado, deberá
            devolver el Préstamo junto con los honorarios acordados en la fecha
            de vencimiento especificada en las Condiciones Particulares.
          </div>

          <div class="desc-li">
            Artículo 7: Disposición y Costes del Préstamo
          </div>
          <div class="desc">
            7.1 Los costes del Préstamo se componen de un interés y una comisión
            de apertura sobre el capital prestado; dichos importes pueden
            consultarse en nuestro Sitio Web o en la Aplicación Móvil, a los
            cuales el Cliente podrá acceder con anterioridad a la formulación de
            su Solicitud de Préstamo. La comisión de apertura se devengará en la
            primera fecha de vencimiento del Préstamo, independientemente de que
            el Prestatario proceda a la devolución anticipada total del importe
            del Préstamo.
          </div>
          <div class="desc">
            7.2 El importe del interés dependerá del capital solicitado y de la
            duración del Préstamo. El tipo de interés aplicado y su cuantía
            estarán detallados en las Condiciones Particulares.
          </div>
          <div class="desc">
            7.3 TEl Préstamo solo podrá ser concedido y amortizado en euros.
          </div>
          <div class="desc">
            7.4 El Préstamo en situación de impago devengará intereses de demora
            conforme a lo establecido en el Artículo 11.
          </div>
          <div class="desc">
            7.5 Desde el vencimiento del Préstamo, una vez que el Prestatario
            haya abonado el cien por cien (100%) del capital, intereses y
            comisión de apertura del Préstamo, y en su caso, penalizaciones y
            otras comisiones, no se le trasladará ningún importe adicional.
          </div>
          <div class="desc">
            7.6 El Prestamista podrá, durante un período determinado y con fines
            promocionales y/o de fidelización de clientes, reducir o exonerar
            total o parcialmente los costes del Préstamo y/o la comisión de
            apertura. La oferta estará sujeta a las Condiciones Particulares que
            se indiquen en los términos de dicha promoción.
          </div>
          <div class="desc">
            En todo caso, cualquier promoción o descuento estará condicionada al
            cumplimiento por parte del Prestatario de las condiciones económicas
            del Préstamo. En caso de impago en la fecha de vencimiento o de
            cualquier otro incumplimiento del Préstamo, el Prestamista reclamará
            al Prestatario la totalidad de los costes del Préstamo, sin
            reducción alguna por promociones o descuentos aplicados.
          </div>

          <div class="desc-li">Artículo 8: Causas de Resolución Anticipada</div>
          <div class="desc">
            El Contrato podrá ser resuelto anticipadamente en caso de impago o
            incumplimiento por parte del Prestatario de cualquiera de sus
            obligaciones esenciales, manifestaciones y, en particular, en caso
            de falta de pago. En tal supuesto, se exigirá la devolución
            inmediata del capital pendiente, junto con cualquier cantidad de
            capital vencida e impagada, intereses vencidos e impagados, y
            comisiones pendientes de pago.
          </div>

          <div class="desc-li">Artículo 9: Reembolso del Préstamo</div>
          <div class="desc">
            9.1 En la fecha de vencimiento, el Prestatario estará obligado a
            abonar al Prestamista el principal del Préstamo, los intereses
            ordinarios y la comisión de apertura, así como cualquier otro
            importe establecido en el Contrato de Préstamo. En todo caso, el
            importe total que deberá abonar el Prestatario en la fecha de
            vencimiento del Préstamo estará detallado en las Condiciones
            Particulares.
          </div>
          <div class="desc">
            9.2 El pago de los importes devengados conforme a la cláusula
            anterior se realizará mediante cargo en la(s) tarjeta(s) de débito
            proporcionada(s) por el Prestatario en la Solicitud de Préstamo. El
            Prestatario autoriza expresamente al Prestamista a cargar dichos
            importes en las mencionadas tarjetas bancarias. El pago también
            podrá realizarse a través del apartado “Pagar” al que el Prestatario
            tiene acceso en su cuenta personal en el Sitio Web o en la
            Aplicación Móvil. El Prestamista podrá igualmente facilitar otras
            opciones de pago en su Sitio Web o Aplicación Móvil.
          </div>
          <div class="desc">
            El Prestatario, mediante la Solicitud de Préstamo, autoriza
            expresamente al Prestamista a efectuar tantos cargos como sean
            necesarios en la(s) tarjeta(s) de débito indicada(s) en la Solicitud
            de Préstamo hasta el pago íntegro del Préstamo, sus comisiones y, en
            su caso, demás costes del mismo. Asimismo, en caso de no disponer de
            saldo suficiente en la(s) tarjeta(s) indicada(s) o de no haber
            registrado ninguna tarjeta, el Prestatario autoriza expresamente al
            Prestamista a cobrar los importes debidos mediante adeudo en la
            cuenta bancaria utilizada para la recepción del Préstamo. A tal
            efecto, el Prestatario proporcionará al Prestamista todos los datos
            y detalles relativos a su(s) cuenta(s) bancaria(s) y a la(s)
            tarjeta(s) de débito correspondiente(s) en el momento de la
            Solicitud del Préstamo.
          </div>
          <div class="desc">
            El Prestamista se reserva el derecho a realizar una validación del
            método de pago indicado por el Prestatario.
          </div>
          <div class="desc">
            9.3 En caso de que la fecha de pago coincida con un día no hábil a
            efectos del presente Contrato, y no se haya proporcionado una
            tarjeta de débito o no se haya autorizado el pago mediante adeudo en
            cuenta bancaria, el pago se efectuará el siguiente Día Hábil
            inmediato.
          </div>
          <div class="desc">
            9.4 Cualquier importe recibido por el Prestamista una vez vencido el
            Préstamo se aplicará en el siguiente orden:
          </div>
          <div class="desc-indent">(1) Intereses de demora, en su caso;</div>
          <div class="desc-indent">
            (2) Comisión por gestiones de recobro (“reclamación de impago”);
          </div>
          <div class="desc-indent">(3) Intereses ordinarios;</div>
          <div class="desc-indent">
            (4) Comisión de apertura (exigible únicamente con el primer pago); y
          </div>
          <div class="desc-indent">
            (5) Reembolso del capital principal del Préstamo correspondiente.
          </div>
          <div class="desc">
            9.5 En caso de impago de cualquier cantidad pendiente por causas
            imputables al Prestatario, éste deberá abonar la penalización
            correspondiente, conforme a lo dispuesto en los Artículos 11 y 12 de
            las Condiciones Generales.
          </div>
          <div class="desc">
            9.6 Si el Prestamista recibe un ingreso que no puede identificar por
            causa imputable al Prestatario, dicho ingreso no se considerará como
            pago hasta que sea debidamente identificado. Por tanto, en caso de
            retraso en el pago por esta causa, el Prestatario estará obligado a
            abonar las penalizaciones y comisiones previstas en los Artículos 11
            y 12.
          </div>
          <div class="desc">
            9.7 El pago se considerará efectuado una vez que quede registrado
            como recibido en la cuenta bancaria del Prestamista.
          </div>

          <div class="desc-li">Artículo 10: Reembolso Anticipado</div>
          <div class="desc">
            10.1 En cualquier momento durante la vigencia del Contrato de
            Préstamo, el Prestatario podrá realizar el reembolso anticipado
            total o parcial del importe del Préstamo. En el momento de efectuar
            dicho reembolso anticipado, el Prestatario deberá abonar el importe
            del Préstamo, las comisiones correspondientes a los días
            transcurridos desde la emisión de la transferencia por parte del
            Prestamista y, en su caso, la comisión de apertura y/o cualquier
            otro cargo que haya sido pactado. El reembolso anticipado también
            podrá realizarse por parte del Prestatario a través de la opción
            habilitada al efecto en el Sitio Web o la Aplicación Móvil del
            Prestamista. El reembolso anticipado no exime al Prestatario del
            pago de la comisión de apertura.
          </div>
          <div class="desc">
            No obstante lo anterior, y cuando resulte aplicable, de conformidad
            con lo dispuesto en el artículo 30 de la Ley 16/2011 de Contratos de
            Crédito al Consumo, durante la vigencia del Préstamo, el Prestatario
            podrá realizar el reembolso anticipado total o parcial del importe
            del Préstamo sin costes adicionales a los indicados en el párrafo
            anterior. En este caso, el Prestamista tendrá derecho a una
            compensación justa y objetiva por los costes derivados del reembolso
            anticipado, la cual no podrá exceder del 0,5% del importe del
            Préstamo.
          </div>

          <div class="desc-li">Artículo 11: Mora en el Pago</div>
          <div class="desc">
            11.1 Además de los importes establecidos en el Artículo 9, el
            Prestatario, en su caso, deberá abonar al Prestamista la
            penalización por mora y el coste por gestión de reclamación de
            posiciones deudoras vencidas (ver Artículo 12).
          </div>
          <div class="desc">
            11.2 En caso de que, en la fecha de vencimiento del Préstamo, alguna
            parte del capital y/o de las comisiones devengadas permanezca
            impagada, el Prestamista se reserva el derecho de imponer una
            penalización por mora. Esta penalización se devengará a un tipo del
            uno por ciento ({{ lateRate }}%) diario, calculado sobre el importe original
            del principal desembolsado al Prestatario, comenzando desde la fecha
            de incumplimiento. La penalización acumulada no podrá superar el
            cien por cien (100%) del importe original del principal. Esta
            penalización será adicional a cualquier importe pendiente conforme
            al Contrato de Préstamo, incluyendo, en su caso, los gastos
            derivados del impago detallados en el Artículo 12.
          </div>

          <div class="desc-li">
            Artículo 12: Reclamación de Posiciones Deudoras Vencidas
          </div>
          <div class="desc">
            12.1 En el supuesto de que, en la fecha de vencimiento, el
            Prestamista no pueda cobrar total o parcialmente los importes
            previstos en las Condiciones Generales, se iniciarán las actividades
            de reclamación de posiciones deudoras vencidas, incluyendo el envío
            de correos electrónicos, SMS, llamadas telefónicas, gestión de
            expedientes con agencias externas, entre otros.
          </div>
          <div class="desc">
            12.2 El Prestatario reconoce y acepta que, una vez vencido el plazo
            y en caso de impago, el Prestamista podrá ponerse en contacto con él
            utilizando cualquiera de los datos de contacto facilitados en la
            Solicitud de Préstamo, con el fin de reclamar los importes
            adeudados.
          </div>
          <div class="desc">
            12.3 En caso de que los importes adeudados por el Prestatario al
            Prestamista no hayan sido satisfechos en su totalidad, el
            Prestamista se reserva el derecho, de conformidad con la legislación
            vigente, de comunicar la situación de impago, previo aviso al
            Prestatario, a los ficheros de solvencia patrimonial y crédito.
            Asimismo, se informa al Prestatario moroso de que el Prestamista
            podrá encomendar la gestión de cobro a un tercero.
          </div>
          <div class="desc">
            12.4 La reclamación de posiciones deudoras vencidas genera costes
            adicionales para el Prestamista. Dichos costes serán asumidos por el
            Prestatario y no tienen carácter penalizador, correspondiendo a los
            gastos en los que incurre el Prestamista por la gestión de dicha
            reclamación. En concreto, por cada caso de impago, el Prestatario
            acepta abonar una comisión fija por reclamación de impago, cuyo
            importe y condiciones se detallan en las Condiciones Particulares
            del presente Contrato. Esta comisión será exigible por cada impago
            producido y es independiente de cualquier otro cargo o interés que
            pudiera aplicarse.
          </div>
          <div class="desc">
            12.5 El Prestatario reconoce y acepta expresamente que el
            requerimiento de pago podrá serle comunicado por cualquiera de los
            medios de comunicación que haya facilitado en la Solicitud de
            Préstamo. En este sentido, el Prestatario reconoce que el uso de
            técnicas de contratación a distancia implica que el Prestamista
            pueda contactar con él para cualquier cuestión derivada de la
            relación contractual que les une (incluido el requerimiento de
            pago), por cualquiera de dichos medios, en particular por SMS y
            correo electrónico.
          </div>
          <div class="desc">
            12.6 Excepcionalmente y a exclusiva discreción del Prestamista, este
            podrá ofrecer al Prestatario un plan de pagos para la amortización
            de la deuda pendiente. La suscripción a dicho plan de pagos estará
            sujeta al pago de una comisión de gestión, cuyo importe variará en
            cada caso y será comunicado previamente al Prestatario, así como los
            importes específicos y las fechas correspondientes a los pagos
            pactados. Se entenderá que el Prestatario acepta la propuesta del
            plan de pagos desde el momento en que abone la comisión de gestión
            correspondiente. El incumplimiento por parte del Prestatario de
            cualquiera de los pagos establecidos en el plan de pagos supondrá la
            ineficacia del mismo, generando a partir de ese instante las
            penalizaciones correspondientes por los importes pendientes de pago,
            así como cualquier otro gasto relacionado con la reclamación de
            posiciones deudoras vencidas, conforme a lo previsto en los
            Artículos de las Condiciones Generales.
          </div>

          <div class="desc-li">Artículo 13: Ampliación del Préstamo</div>
          <div class="desc">
            13.1 De conformidad con lo establecido en el Contrato de Préstamo,
            desde la fecha en que se desembolsa el Préstamo y hasta la fecha de
            vencimiento de la primera cuota del Préstamo (inclusive), el
            Prestatario podrá solicitar al Prestamista una ampliación voluntaria
            del Préstamo. El período de ampliación voluntaria será de siete (7)
            o catorce (14) días, según la opción seleccionada por el Prestatario
            a través del Servicio Remoto correspondiente. El Prestamista se
            reserva el derecho exclusivo de denegar la solicitud de ampliación
            voluntaria. Para beneficiarse de la ampliación voluntaria, el
            Prestatario deberá pagar por adelantado los costes relacionados con
            la ampliación del Préstamo, los cuales consisten exclusivamente en
            las comisiones del Préstamo devengadas durante el período de
            ampliación voluntaria. Si el Prestamista emite una decisión
            favorable, la selección del Prestatario registrada por el sistema
            del Servicio Remoto formará parte integral del Contrato de Préstamo
            y tendrá el mismo efecto legal.
          </div>
          <div class="desc">
            13.2 Al finalizar el período de ampliación voluntaria, el
            Prestatario deberá abonar el importe total derivado del Préstamo
            solicitado, tal como se indica en el Artículo 9.
          </div>
          <div class="desc-li">
            Artículo 14: Responsabilidad del Prestatario por la Provisión de
            Información Incorrecta o Falsa
          </div>
          <div class="desc">
            14.1 En el caso de que el Prestatario haya proporcionado información
            incorrecta o falsa en su Solicitud de Préstamo, el Prestamista
            tendrá derecho a resolver automáticamente el Préstamo en cualquier
            momento, incluso antes de la fecha de vencimiento.
          </div>
          <div class="desc">
            14.2 En caso de que el Prestamista decida resolver el Contrato de
            Préstamo por este motivo, tendrá derecho a reclamar la devolución
            del importe del Préstamo, los intereses generados hasta ese momento,
            así como la comisión de apertura indicada en las Condiciones
            Particulares. Dicha recuperación se efectuará mediante cargo en
            la(s) tarjeta(s) de débito del Prestatario.
          </div>
          <div class="desc">
            14.3 En caso de que se proporcione información falsa o incorrecta, o
            se produzca una suplantación de identidad por parte del Prestatario,
            el Prestamista informa que podrá emprender las acciones legales que
            considere necesarias para resarcirse de los daños ocasionados, así
            como, en su caso, informar a la policía o a las autoridades
            competentes para la realización de las investigaciones pertinentes.
          </div>

          <div class="desc-li">Artículo 15: Derecho de desistimiento</div>
          <div class="desc">
            15.1 El Prestatario dispondrá de un plazo de catorce (14) días
            naturales a partir de la fecha de emisión de la Decisión de Préstamo
            para desistir del Contrato, sin necesidad de indicar motivo alguno y
            sin penalización alguna.
          </div>
          <div class="desc">
            15.2 Para que el desistimiento sea efectivo, el Prestatario deberá
            comunicar su intención de ejercer el derecho de desistimiento al
            Prestamista, siempre dentro del plazo mencionado, mediante el mismo
            medio de comunicación a distancia utilizado para la contratación del
            Préstamo. Adicionalmente, podrá realizarse por cualquier otro medio
            admitido en derecho que permita dejar constancia de la notificación.
            La comunicación deberá estar debidamente firmada e incluir el nombre
            completo del Prestatario, su número de documento de identidad, una
            copia del mismo y la fecha de emisión de la Decisión de Préstamo.
          </div>
          <div class="desc">
            15.3 El Prestatario deberá devolver al Prestamista cualquier
            cantidad recibida antes del ejercicio de su derecho de
            desistimiento, así como abonar los honorarios del Préstamo y/o los
            costes financieros devengados entre la fecha de recepción del
            Préstamo y la fecha de devolución del capital, conforme al tipo de
            interés pactado. Dichos importes deberán ser reembolsados al
            Prestamista lo antes posible y, en todo caso, dentro de los treinta
            (30) días naturales siguientes al envío de la notificación de
            desistimiento al Prestamista.
          </div>

          <div class="desc-li">Artículo 16: Personal Data</div>
          <div class="desc">
            16.1 En cumplimiento de lo dispuesto en el Reglamento General de
            Protección de Datos y demás normativa aplicable, el Solicitante del
            Préstamo podrá consultar la información relativa al tratamiento de
            sus datos personales en nuestra Política de Privacidad, accesible a
            través del Sitio Web o de la Aplicación Móvil del Prestamista. Sin
            perjuicio de lo contenido en dicha Política de Privacidad, el
            Prestamista tratará los datos del Solicitante para las finalidades y
            bajo las condiciones específicas que se indican en esta sección.
          </div>
          <div class="desc">
            16.2 El Prestamista, en calidad de Responsable del Tratamiento y con
            domicilio social en Paseo de la Castellana 194, 28046 Madrid,
            informa al Cliente de que los datos proporcionados en la Solicitud
            de Préstamo, ya sea a través del Sitio Web o de la Aplicación Móvil,
            serán tratados con las siguientes finalidades:
          </div>
          <div class="desc-indent">
            i. La formalización, mantenimiento, desarrollo y control de la
            relación contractual o precontractual (incluyendo la evaluación,
            valoración y seguimiento del riesgo crediticio que, en su caso,
            dicha relación pueda implicar, mediante técnicas de scoring y
            análisis experto). La base legítima para este tratamiento es la
            ejecución del contrato del que el Cliente es parte o la aplicación
            de medidas precontractuales. Si el Cliente no facilita los datos
            personales necesarios para esta finalidad, no podrá formalizarse el
            Contrato. Este tratamiento podrá incluir la recepción de llamadas y
            comunicaciones automáticas, en los términos expresados en las
            presentes Condiciones Generales. Asimismo, salvo que exista otra
            base legal aplicable, se solicitará el consentimiento del
            Prestatario para recibir dichas llamadas y comunicaciones. En caso
            de no facilitar los datos personales requeridos, no será posible
            formalizar el Contrato.
          </div>
          <div class="desc-indent">
            ii. La prevención del fraude. La base legítima de este tratamiento
            es el interés legítimo del Prestamista en evitar operaciones que
            puedan comprometer su solvencia económica.
          </div>
          <div class="desc-indent">
            iii. El cumplimiento de obligaciones legales del Prestamista, como
            por ejemplo, en materia de prevención del blanqueo de capitales. En
            estos casos, la base legal que legitima el tratamiento será el
            cumplimiento de una obligación legal aplicable al Prestamista.
          </div>
          <div class="desc-indent">
            iv. El envío de información comercial sobre productos y servicios,
            por medios electrónicos: realización de actividades y comunicaciones
            comerciales, publicitarias y promocionales por cualquier medio
            electrónico (de conformidad con el artículo 21 de la Ley 34/2002, de
            11 de julio, de servicios de la sociedad de la información y
            comercio electrónico), incluyendo el envío de correos electrónicos,
            SMS, MMS, u otros sistemas de mensajería, por parte del Prestamista,
            incorporando información sobre productos y servicios comercializados
            por este, incluyendo promociones especiales y programas de
            fidelización. La base de legitimación es el interés legítimo del
            Prestamista. En todo caso, el Cliente podrá oponerse al envío de
            dichas comunicaciones comerciales enviando un correo electrónico a
            la dirección {{ emailNo }}, indicando su Documento Nacional de
            Identidad o documento identificativo equivalente, con el fin de
            permitir su correcta identificación, sin perjuicio de que se le
            pueda requerir información adicional para verificar su identidad.
          </div>
          <div class="desc-indent">
            v. La cesión total o parcial a terceros de su posición contractual,
            derechos de cobro por impagos y/o derechos de crédito, así como la
            constitución de garantías sobre dichos derechos, compartiendo los
            datos del Prestatario para los fines anteriormente descritos. La
            base legal principal para este tratamiento es la relación
            contractual existente entre el Prestamista y el Prestatario.
          </div>
          <div class="desc">
            16.3 El Prestamista trata los datos personales del Cliente, tales
            como: nombre y apellidos, fecha de nacimiento, número de documento
            de identidad, domicilio, cuenta bancaria, ingresos mensuales, correo
            electrónico, dirección IP, número de teléfono móvil y fijo, y
            cualquier otro dato que el Cliente decida proporcionar a través del
            uso del teléfono y/o correo electrónico. Asimismo, se podrán tratar
            datos como sexo, estado civil, número de hijos, situación laboral,
            empresa en la que trabaja, teléfono del trabajo, ingresos y gastos
            mensuales, información financiera y de tarjetas de crédito, número
            de cuenta bancaria, movimientos en la cuenta bancaria, descripción
            personal, grabaciones de voz, fotografías o imágenes, imagen del
            documento de identidad, firma y cualquier otra información que el
            Cliente facilite voluntariamente.
          </div>
          <div class="desc">
            16.4 Estos datos se recogen a través de la Aplicación Móvil y/o del
            Sitio Web, con el fin de gestionar la Solicitud de Préstamo, así
            como la relación precontractual y contractual. Para el análisis, y
            en su caso, la concesión, seguimiento y control de la financiación
            solicitada, el Prestamista podrá recabar información relativa al
            historial crediticio y posiciones de riesgo del Cliente, procedente
            de entidades que prestan servicios de información sobre solvencia
            patrimonial y crédito (en particular, el fichero Experian -
            Badexcug).
          </div>
          <div class="desc">
            16.5 Asimismo, el Prestamista podrá recibir información sobre el
            Cliente por parte de afiliados, entidades financieras, proveedores,
            encargados del tratamiento y fuentes de acceso público, relativa a
            su solvencia económica, situación financiera, deudas, estado laboral
            y registros relevantes (incluyendo información sobre ingresos,
            historial crediticio, deudas con terceros, domicilios, documentos de
            identidad falsos, fraudes, blanqueo de capitales, financiación del
            terrorismo y condición de persona políticamente expuesta). El
            Cliente podrá acceder a la Política de Privacidad a través del Sitio
            Web o la Aplicación Móvil del Prestamista para obtener información
            adicional sobre estos terceros.
          </div>
          <div class="desc">
            16.6 Además, el Prestamista podrá recibir información de bancos,
            entidades financieras y de pago, relativa a cargos abonados por el
            Cliente; así como de socios comerciales encargados de la prestación
            de servicios técnicos, de pago y entrega, de redes publicitarias,
            proveedores de análisis y buscadores cuando presten servicios al
            Prestamista.
          </div>
          <div class="desc">
            16.7 Adicionalmente, se informa al Cliente de lo siguiente:
          </div>
          <div class="desc-indent">
            a) Para el análisis y, en su caso, concesión, seguimiento y control
            de la financiación solicitada, podremos recabar información relativa
            a su historial crediticio y posiciones de riesgo de proveedores de
            servicios de información sobre solvencia y crédito (en particular,
            del fichero Experian - Badexcug).
          </div>
          <div class="desc-indent">
            b)Los datos personales del Cliente podrán ser comunicados a otras
            entidades del grupo NÉBULA con fines administrativos internos
            (basado en el interés legítimo del responsable del tratamiento) y
            para la prevención del fraude (como resultado de obligaciones
            legales, en particular, en relación con la prevención del blanqueo
            de capitales y financiación del terrorismo).
          </div>
          <div class="desc-indent">
            c) Igualmente, en caso de impago en el plazo previsto, y una vez
            cumplidos los requisitos legales y comunicaciones pertinentes, los
            datos personales del Cliente podrán ser comunicados al sistema común
            de información crediticia de Experian - Fichero Badexcug.
          </div>
          <div class="desc-indent">
            d) Como se ha indicado anteriormente, y en cumplimiento de
            obligaciones legales, especialmente en materia de prevención del
            blanqueo de capitales y financiación del terrorismo, el Prestamista
            podrá comunicar los datos personales del Cliente a autoridades
            competentes u organismos oficiales.
          </div>
          <div class="desc-indent">
            e) El Prestamista podrá comunicar los datos personales del Cliente a
            otras autoridades u organismos oficiales en caso de que exista una
            obligación legal que así lo requiera.
          </div>
          <div class="desc-indent">
            f) Para la correcta ejecución del Contrato, el Prestamista podrá dar
            acceso a los datos personales del Cliente a colaboradores o socios,
            garantizando en todo momento el cumplimiento de la normativa
            aplicable sobre almacenamiento y tratamiento de datos, y de
            conformidad con lo previsto en nuestra Política de Privacidad. En
            caso de que dichos colaboradores tengan acceso a datos personales,
            se habrá suscrito con ellos el correspondiente contrato de encargado
            del tratamiento, conforme a la normativa vigente. Los colaboradores
            o socios de NÉBULA gozan de nuestra plena confianza y desarrollan su
            actividad respetando la legislación en materia de protección de
            datos, aplicando medidas de seguridad adecuadas.
          </div>
          <div class="desc-indent">
            g) Para cumplir con la normativa sobre prevención del blanqueo de
            capitales y otras obligaciones legales, el Cliente autoriza
            expresamente al Prestamista a solicitar a la Tesorería General de la
            Seguridad Social (TGSS) la información necesaria relacionada con su
            actividad económica, con el fin de verificar la veracidad de los
            datos facilitados durante el transcurso de la relación comercial. En
            caso de que existan discrepancias entre la información proporcionada
            por el Cliente y los registros de la TGSS, nos reservamos el derecho
            de enviar a la TGSS la información necesaria para completar el
            proceso de verificación y garantizar tanto la seguridad de sus datos
            como el cumplimiento de la normativa antifraude.
          </div>
          <div class="desc-indent">
            h) Para la validación de la cuenta bancaria del Cliente, podremos
            recopilar información a través del servicio de Agregación de
            Información de Cuentas (“openbanking”) ofrecido por UNNAX REGULATORY
            SERVICES, E.D.E., S.L.U.
          </div>
          <div class="desc">
            16.8 El Prestamista podrá permitir el acceso a los datos personales
            del Cliente a sus proveedores de servicios. Estos proveedores pueden
            encontrarse en países situados fuera del Espacio Económico Europeo.
            En aquellos países en los que no se haya declarado que cuentan con
            un nivel de protección equivalente al europeo, el Prestamista
            adoptará las cláusulas contractuales tipo correspondientes.
          </div>
          <div class="desc">
            16.9 Los datos personales del Cliente serán objeto de decisiones
            automatizadas con el fin de: (i) evaluar su solvencia económica a
            efectos de la concesión del Préstamo, (ii) realizar las operaciones
            de "Conozca a su Cliente" (KYC), (iii) detectar operaciones
            fraudulentas y (iv) decidir si procede o no modificar el Préstamo.A
            tal efecto, mediante el análisis de determinados datos personales,
            seleccionados conforme a los fines anteriormente indicados y con
            base en criterios objetivos previamente establecidos por el
            Prestamista, se determinará si procede o no: (i) conceder el
            Préstamo, (ii) continuar con la contratación, evitando relaciones
            comerciales con personas vinculadas con el terrorismo, la corrupción
            o el blanqueo de capitales, (iii) detectar comportamientos
            sospechosos durante la contratación que puedan suponer un intento de
            engaño al Prestamista y/o (iv) proceder a la modificación del límite
            del Préstamo.
          </div>
          <div class="desc">
            16.10 Sin perjuicio de lo anterior, si el Cliente no está conforme,
            podrá oponerse a estas decisiones automatizadas, aportando la
            información que estime oportuna para refutar la decisión adoptada, y
            solicitar que dicha decisión sea revisada manualmente.
          </div>
          <div class="desc">
            16.11 Si durante el proceso de solicitud el Cliente acepta
            voluntariamente la validación de su cuenta bancaria a través del
            servicio de Agregación de Información de Cuentas ofrecido por UNNAX
            (UNNAX REGULATORY SERVICES, E.D.E., S.L.U.), otorgando acceso a sus
            datos financieros, el Cliente autoriza a NÉBULA a acceder, a través
            de dicho servicio, a la información relativa a los movimientos de la
            cuenta bancaria, conforme a los fines establecidos en la cláusula
            16.2 de las presentes Condiciones Generales y de acuerdo con la
            normativa aplicable.
          </div>
          <div class="desc">
            16.12 El Prestamista ha designado un Delegado de Protección de Datos
            (DPO), a quien el Cliente podrá dirigirse para cualquier consulta
            relacionada con el tratamiento de sus datos personales. El correo
            electrónico de contacto es: dpo@prestalight.com.
          </div>
          <div class="desc">
            16.13 El Cliente podrá obtener más información sobre las decisiones
            automatizadas que podemos llevar a cabo y sobre los plazos de
            conservación de sus datos personales en nuestra Política de
            Privacidad. Asimismo, podrá ejercer los derechos de acceso,
            rectificación, oposición, supresión, limitación y portabilidad, así
            como retirar su consentimiento en cualquier momento, ante el
            responsable del tratamiento, NÉBULA FINANCE S.A., con N.I.F.
            A75607945 y domicilio en Paseo de la Castellana 194, 28046 Madrid, o
            mediante correo electrónico dirigido a nuestro Delegado de
            Protección de Datos: dpo@prestalight.com, adjuntando fotocopia de su
            documento de identidad u otro documento equivalente que acredite su
            identidad. Le informamos de que también podrá presentar una
            reclamación ante la Agencia Española de Protección de Datos (AEPD),
            autoridad de control competente, en la dirección C/ Jorge Juan, 6 –
            28001 Madrid, o a través del siguiente enlace:
            <span
              class="link mark-text"
              @click="openLink('https://sedeagpd.gob.es.')"
              >https://sedeagpd.gob.es.</span
            >
          </div>
          <div class="desc">
            16.14 En caso de que el Cliente ejerza su derecho de rectificación
            de datos, deberá indicar los datos erróneos y la corrección que se
            desea realizar, acompañada de la documentación justificativa. Si no
            se acredita debidamente lo anterior, se denegará la rectificación
            conforme a lo dispuesto en la normativa vigente.
          </div>
          <div class="desc">
            16.15 Los datos personales facilitados por el Cliente serán tratados
            durante el tiempo necesario para cumplir con la finalidad para la
            que fueron recabados. Una vez alcanzada dicha finalidad, retirado el
            consentimiento, o en caso de supresión o rectificación, los datos
            serán debidamente bloqueados durante el tiempo necesario para
            atender o exigir posibles responsabilidades derivadas de la
            finalidad del tratamiento. Transcurrido dicho plazo, los datos
            personales serán eliminados de forma definitiva de nuestros sistemas
            y/o anonimizados de manera segura.
          </div>
          <div class="desc">
            16.16 El Cliente tiene la obligación de comunicar al Prestamista
            cualquier modificación en la información facilitada en relación con
            la Solicitud de Préstamo.
          </div>
          <div class="desc">
            16.17 Información adicional sobre el tratamiento de datos personales
            está disponible en la Política de Privacidad del Prestamista,
            accesible desde el Sitio Web o la Aplicación Móvil.
          </div>
          <div class="desc">
            16.18 El uso de cookies es necesario para el funcionamiento del
            Sitio Web y la Aplicación Móvil. Las cookies se utilizan para
            mejorar la experiencia de navegación, gestionar el contenido de las
            solicitudes de crédito y ofrecer asesoramiento u ofertas
            personalizadas. El Cliente podrá configurar su navegador para ser
            notificado de la recepción de cookies y para impedir su instalación
            en el disco duro. Se recomienda consultar las instrucciones y
            manuales del navegador para más información. Puede obtener más
            información sobre el uso de cookies en nuestra Política de Cookies,
            disponible en el Sitio Web o la Aplicación Móvil del Prestamista.
          </div>

          <div class="desc-li">Artículo 17: Cesión de derechos</div>
          <div class="desc">
            El Prestamista se reserva el derecho de ceder total o parcialmente
            su posición contractual a cualquier tercero que considere adecuado,
            a través de la fórmula legal que estime más conveniente, sin que
            dicha cesión afecte en modo alguno a los derechos u obligaciones
            reflejados en este Contrato, de forma que el cesionario asumirá los
            derechos, obligaciones y responsabilidades derivadas del presente
            Contrato desde la posición actual del Prestamista, subrogándose en
            dicha posición sin limitación alguna frente al Prestatario.
          </div>

          <div class="desc">
            Dada la naturaleza estrictamente personal de este Contrato, el
            Prestatario no podrá ceder su posición contractual a ningún tercero.
          </div>

          <div class="desc-li">
            Artículo 18: Datos de contacto y notificaciones
          </div>
          <div class="desc">
            El Prestatario acepta expresamente que las comunicaciones,
            notificaciones y documentación que el Prestamista remita o deba
            remitir en virtud del Contrato o de la legislación aplicable se
            enviarán preferentemente a través de su área de cliente en el Sitio
            Web o Aplicación Móvil, a su dirección de correo electrónico, a los
            números de teléfono de contacto proporcionados, mediante llamada
            telefónica, SMS o por correo postal al domicilio del Prestatario.
          </div>
          <div class="desc">
            El Prestatario se compromete a notificar cualquier cambio de
            domicilio, dirección de correo electrónico, número de teléfono y
            cuenta bancaria previamente facilitados al Prestamista, de manera
            que solo serán válidos los últimos datos comunicados.
          </div>
          <div class="desc">
            Asimismo, el Prestatario se compromete a informar al Prestamista de
            cualquier modificación en su situación personal y/o económica o
            financiera.
          </div>
          <div class="desc">
            Todos los datos facilitados en la Solicitud de Préstamo podrán ser
            utilizados por el Prestamista cuando resulten útiles para la
            localización del Prestatario, especialmente en caso de impago del
            Préstamo, incluyendo la notificación de actos procesales.
          </div>
          <div class="desc">
            El Prestamista no será responsable en ningún momento por cualquier
            pérdida o daño que pudiera surgir y ser causado al Prestatario como
            consecuencia de no haber proporcionado al Prestamista la
            actualización de sus datos de contacto, impidiendo así que el
            Prestatario haya podido ser debidamente notificado de comunicaciones
            de su interés.
          </div>
          <div class="desc">
            En el caso de una posible inclusión del Cliente en los ficheros de
            solvencia patrimonial por impago, y a efectos de lo dispuesto en el
            artículo 20.1.c) de la normativa vigente en materia de protección de
            datos, no se considerará suficiente para impedir la comunicación de
            datos relativos a un Prestatario, aquellos retornos en los que el
            destinatario haya rehusado recibir el envío, o aquellos en los que,
            habiendo sido devueltos, se verifique que el domicilio utilizado
            para realizar la notificación corresponde al convenido
            contractualmente con el Prestatario a efectos de notificaciones.
          </div>
          <div class="desc">
            Siempre que el Prestatario pueda dar instrucciones al Prestamista
            por teléfono o por Internet mediante el uso de su código de
            identificación personal, dicho código podrá sustituir la firma del
            Prestatario, manteniendo el mismo valor legal. A efectos de
            justificar las órdenes recibidas y utilizarlas como prueba dentro o
            fuera de juicio, el Prestatario acepta que, en cualquier
            comunicación mantenida con el Prestamista por vía telefónica o
            telemática, el Prestamista podrá grabar las conversaciones y
            conservar los correspondientes soportes magnéticos o registros.
          </div>

          <div class="desc-li">Artículo 19: Otras disposiciones</div>
          <div class="desc">
            19.1 El Prestatario tiene el deber de informar al Prestamista sobre
            cualquier cambio en la información facilitada en la Solicitud de
            Préstamo. En particular, deberá comunicar cualquier modificación en
            la cuenta bancaria, el número de tarjeta bancaria y los datos de
            contacto tales como: dirección de correo electrónico, números de
            teléfono de contacto y dirección postal.
          </div>

          <div class="desc-li">
            Artículo 20: Reclamaciones, quejas y solicitudes de información
          </div>
          <div class="desc">
            20.1 El Prestatario podrá dirigir sus reclamaciones, quejas o
            solicitudes de información al Servicio de Atención al Cliente a
            través de cualquiera de los siguientes canales:
          </div>
          <div class="desc">
            Envío de un correo electrónico a: {{ emailNo }}
          </div>
          <div class="desc">
            Llamada telefónica al número: {{ servicePhoneNo }}
          </div>
          <div class="desc">
            20.2 El Prestamista se esforzará en responder lo antes posible, sin
            perjuicio del plazo máximo establecido por la normativa aplicable
            para este tipo de procedimientos.
          </div>
          <div class="desc">
            20.3 No existen procedimientos extrajudiciales de resolución de
            reclamaciones disponibles para los Clientes. No obstante, cualquier
            Cliente (Prestatario), para la resolución de litigios en línea
            conforme al Artículo 14.1 del Reglamento (UE) 524/2013, podrá
            utilizar la plataforma de resolución de litigios en línea habilitada
            por la Comisión Europea, disponible en el siguiente enlace:
            http://ec.europa.eu/consumers/odr/.
          </div>
          <div class="desc">
            Dicha plataforma solo será aplicable para Clientes (Prestatarios)
            que residan en el Espacio Económico Europeo y que deseen presentar
            una reclamación contra el Prestamista. No será aplicable, por tanto,
            a disputas de consumo localizadas fuera del Espacio Económico
            Europeo.
          </div>
          <div class="desc">
            20.4 Se informa expresamente que el Prestamista no está obligado a
            utilizar dicha plataforma para la resolución de conflictos con sus
            Prestatarios, ni asume ningún compromiso al respecto.
          </div>
          <div class="desc">
            20.5 En cualquier caso, si tuviera alguna queja o preocupación,
            puede contactarnos enviando un correo electrónico a
            {{ emailNo }}, o bien escribirnos a la siguiente dirección:
          </div>
          <div class="desc">Paseo de la Castellana 194, Madrid – 28046</div>
          <div class="desc">
            Asimismo, se informa al Prestatario que, en caso de reclamación,
            podrá acudir a la Oficina de Atención al Consumidor correspondiente
            a su lugar de residencia.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, onMounted, ref, watch } from 'vue';
import router from '@/router';
import { useRoute } from 'vue-router';
import { channelMethods, postToApp } from '@/utils/channelMethod';
import { formatDate, formatDateTime, getCredential, getKey } from '@/utils';
import {
  officialAddress,
  email,
  website,
  companyName
} from '@/utils/orderConfig';
import { _fetchJustifyLiquidate, _repaymentAgreementInfo } from '@/api/help';

export default {
  name: 'orderTerms',
  methods: {
    addressL: officialAddress,
    emailL: email,
    miWebsite: website,
    formatDateTime,
    companyNameL: companyName
  },
  setup() {
    const loading = ref(false);
    const route = useRoute();

    const dialogMode = computed(() => {
      return true;
    });

    const isInApp = computed(() => {
      return getCredential();
    });

    const handleBackClick = () => {
      postToApp(channelMethods.goBack);
    };

    const handleScroll = (event: any) => {
      if (dialogMode.value) {
        let scrollTop = event.target.scrollTop;
        let scrollHeight = event.target.scrollHeight;
        let clientHeight = event.target.clientHeight;
        console.log('onScroll', scrollTop, scrollHeight, clientHeight);
        if (scrollTop + clientHeight >= scrollHeight - 100) {
          console.log('onScrollEnd');
          postToApp(channelMethods.scrollToEnd, 'true');
        }
      }
    };

    const openLink = (url: any) => {
      window.open(url, '_blank');
    };

    const agreementData = ref<any>({});

    const agreementNo = computed(() => {
      return agreementData.value?.reconcileWithdraw ?? '-';
    });

    // same with start day
    const disbursementDate = computed(() => {
      return agreementData.value?.remedyMotivate ?? '-';
    });

    const Borrower = computed(() => {
      return agreementData.value?.interpretIncorporate ?? '-';
    });

    const address = computed(() => {
      return agreementData.value?.monetize ?? '-';
    });

    const invest = computed(() => {
      return agreementData.value?.invest ?? '-';
    });

    const idNo = computed(() => {
      return agreementData.value?.selectWithdraw ?? '-';
    });

    const orderAmount = computed(() => {
      return agreementData.value?.remedyJustify ?? '-';
    });

    const interestFee = computed(() => {
      return agreementData.value?.scheduleJustify ?? '-';
    });

    const managementFee = computed(() => {
      return agreementData.value?.exhibitJustify ?? '-';
    });

    const repayMoney = computed(() => {
      return agreementData.value?.identifyJustify ?? '-';
    });

    const apr = computed(() => {
      return agreementData.value?.surplusSecurities ?? '-';
    });

    const period = computed(() => {
      return agreementData.value?.remedyRely ?? '-';
    });

    const repaymentList = computed(() => {
      return agreementData.value?.identifyCorrelate || [];
    });

    const tae = computed(() => {
      return agreementData.value?.surplusSimplifySecurities ?? '-';
    });

    const collectionFee = computed(() => {
      return agreementData.value?.reorganizeExplore ?? '-';
    });

    const lateRate = computed(() => {
      return agreementData.value?.regulateSecurities ?? '-';
    });

    const startDate = computed(() => {
      return formatDate(agreementData.value?.forwardAnnuity) ?? today.value;
    });

    const today = computed(() => {
      return formatDate(new Date().getTime());
    });

    const end = computed(() => {
      return (
        formatDate(agreementData.value?.simulationDigitalAnnuity) ??
        'visible after successful disbursement'
      );
    });

    const idType = computed(() => {
      return agreementData.value?.tokenizationActive ?? '-';
    });

    const phoneNo = computed(() => {
      return agreementData.value?.overtakeVisualization ?? '-';
    });

    const birth = computed(() => {
      return formatDate(agreementData.value?.overtakeSlot);
    });

    const firstDays = computed(() => {
      return agreementData.value?.vfihb_xtq;
    });

    const borrowId = computed(() => {
      return route.query.id;
    });

    const pid = computed(() => {
      return route.query.pid;
    });

    const loanMoney = computed(() => {
      return route.query.amount ?? 0;
    });

    const isNormalTag = computed(() => {
      return route.query.tag === '1';
    });

    const loanTerm = computed(() => {
      return route.query.term;
    });

    const onLoad = () => {
      if (!isNormalTag.value) {
        loading.value = true;
        let params = {
          performSelect: borrowId.value,
          remedyJustify: loanMoney.value ? Number(loanMoney.value) : undefined,
          remedyInvoice: loanTerm.value ? Number(loanTerm.value) : undefined,
          scheduleSecuritiesSelect: pid.value
        };
        _repaymentAgreementInfo(params)
          .then(res => {
            console.log('_repaymentAgreementInfo: ', res);
            agreementData.value = res;
          })
          .catch(err => {})
          .finally(() => {
            loading.value = false;
          });
      }
    };

    const resultData = ref<any>();

    const emailNo = computed(() => {
      return (
        resultData.value?.filter((item: any) => item.expand === '3')[0]
          ?.monitor ?? 'clientes@prestalight.com'
      );
    });

    const servicePhoneNo = computed(() => {
      return (
        resultData.value?.filter((item: any) => item.expand === '2')[0]
          ?.monitor ?? '917905850'
      );
    });

    const onLoadServiceInfo = () => {
      _fetchJustifyLiquidate({})
        .then((res: any) => {
          console.log('_repaymentAgreementInfo: ', res['justifyLiquidate']);
          const resultList = res['justifyLiquidate'];
          if (resultList) {
            resultData.value = resultList;
          }
        })
        .catch(err => {})
        .finally(() => {});
    };

    onMounted(() => {
      document.title = 'Agreement';
      // postToApp(channelMethods.darkMode, 'default');
      onLoad();
      onLoadServiceInfo();
    });

    return {
      loading,
      isInApp,
      dialogMode,
      isNormalTag,
      agreementData,
      agreementNo,
      disbursementDate,
      repayMoney,
      Borrower,
      idType,
      idNo,
      phoneNo,
      birth,
      orderAmount,
      period,
      startDate,
      end,
      interestFee,
      managementFee,
      tae,
      collectionFee,
      lateRate,
      apr,
      firstDays,
      repaymentList,
      address,
      invest,
      handleBackClick,
      handleScroll,
      openLink,
      emailNo,
      servicePhoneNo
    };
  }
};
</script>

<style lang="scss" scoped>
.list-container {
  width: 100vw;
  height: 100vh;
  max-width: $max-width;
  position: relative;

  display: flex;
  flex-direction: column;
}

.logo-icon {
  height: 64px; /* Adjust icon size */
  width: 240px; /* Adjust icon size */
}
</style>
